export const AUTH_TYPES = [
  { value: 'mtls', label: 'mTLS' },
  { value: 'xpay', label: 'X-Pay Token' },
] as const;

export const CYBERSOURCE_AUTH_TYPES = [
  { value: 'http_signature', label: 'HTTP Signature' },
  { value: 'jwt', label: 'JWT' },
] as const;

export const TEST_URLS: Record<string, string> = {
  authorize: 'https://apitest.authorize.net/',
  vdp: 'https://sandbox.api.visa.com/',
  cybersource: 'https://apitest.cybersource.com/',
};

export const MODE_LABELS: Record<string, string> = {
  vdp: 'VDP',
  cybersource: 'CyberSource',
  authorize: 'Authorize.Net',
};
